import alarmIcon from "images/header_alarm.svg";
import searchIcon from "images/search.svg";

export default class PageHeaderController {
  $onInit() {
    this.alarmIcon = alarmIcon;
    this.searchIcon = searchIcon;
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/components/page-header/page-header.controller.js